import { z } from "zod";
export const squadraOperatoreSchema = z.object({
    operatore_id: z.string().uuid(),
    nome: z.string(),
    cognome: z.string(),
    username: z.string(),
});
export const squadraSchema = z.object({
    id: z.string().uuid(),
    nome: z.string().max(120),
    attiva: z.boolean(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    operatori: z.array(squadraOperatoreSchema).optional(),
});
export const createSquadraSchema = z.object({
    nome: z.string().min(1).max(120),
});
export const addOperatoreSquadraSchema = z.object({
    operatore_id: z.string().uuid(),
});
//# sourceMappingURL=squadre.js.map